import { Component, ReactElement } from 'react';
import errorTracker from '../../utils/error-tracker';
import translation from '../../languages';

type ErrorBoundaryProps = TranslationProps & {
    children: ReactElement;
    withText?: boolean;
};
type ErrorBoundaryState = {
    hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: Error) {
        try {
            this.captureDecoratedException(error);
        } catch (e) {
            this.captureException(error);
        }
    }

    captureDecoratedException = (error: Error) => {
        error.name = `[white screen prevented]: ${error.name}`;
        console.log(error);
        this.captureException(error);
    };

    captureException = (error: Error) => {
        errorTracker.captureException(error, true);
    };

    render() {
        const { t } = this.props;

        if (this.state.hasError) {
            return (
                this.props.withText && (
                    <div className='container text-center error-message mt-5'>
                        {t('common.errorBoundary.pageError')}
                    </div>
                )
            );
        }

        return this.props.children;
    }
}

const translate = translation('common');

export default translate(ErrorBoundary);
